import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import { ConfirmDialog, DocumentPreviewDialog } from 'src/ui/library/Dialog';
import { TableLanding } from 'src/ui/library/Table/extensions';
import { createRowMap, createTableColumns } from 'src/helpers';
import documentsActions from '../state/documentsActions';
import FileViewer from 'react-file-viewer';
import infoIconlabel from 'src/assets/PreviewIcon.png';
import _ from 'lodash';
import mime from 'mime-types';
import Grid from '@material-ui/core/Grid';
import DOMPurify from 'dompurify';
import {
  getUserRolesSelector,
  getUserInfoSelector,
  isEYProSelector,
  isApplicantSelector,
  isCorpClientSelector,
  isCorporateClientLineManagerSelector,
  isRestrictedCorpMemberSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { addToHistory } from 'src/utils/utilsActions';
import { withSnackbar } from 'notistack';
import adobeLaunch from 'src/helpers/adobeLaunch';
import { fireViewStartCustomEvent } from 'src/helpers/adobeCustomEvents';
import { StorageService } from 'src/helpers/localStorageService';
import {
  LAUNCH_ADOBE,
  DOC_UPLOAD_NEW_URL,
  DOCUMENTS_DETAIL_URL,
  DOCUMENTS_FAST_FILTERS,
  DOCUMENTS_CASE_COMPOSE_URL,
} from 'src/constants/constants.js';
import {
  getFiltersAPI,
  getDocumentsAPI,
  deleteDocumentWithCaseDocumentAPI,
  openDocumentAPI,
  getDocumentsTasksAPI,
} from 'src/services/documents.service';
import { PageTitle } from 'src/ui/library/PageTitle';
import ListIcon from '@material-ui/icons/List';
import DownloadIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import { formatDate, toMoment, addDays } from 'src/helpers/date';
import Spinner from 'src/ui/library/Spinner/Spinner';
import DocUploadContainer from './DocUploadContainer';
import DocumentsDetailContainer from './DocumentsDetailContainer';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { setSelectedMenuType } from 'src/ui/features/Dashboard/state/dashboardActions';
import AddIcon from '@material-ui/icons/Add';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { withStyles } from '@material-ui/core/styles';
import { fnShowNewDashboard, fnGetIsAllDataFlag, extractTimeFromDate } from 'src/helpers/commonFunctions';
import { fnIsDefaultOldView } from 'src/helpers/commonFunctions';

const useStyles = color => ({
  switch: {
    '& .Mui-checked': {
      color: 'green',
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'green !important',
    },
  },
  formControlLabel: {
    color: 'green',
  },
});
class DocumentsLandingContainer extends React.Component {
  static defaultProps = {
    hideLandingHeader: false,
  };

  state = {
    openDialog: false,
    filterCheckBoxChecked: null,
    documentIdToDelete: null,
    hash: !this.props.isTaskFlow
      ? decodeURI(this.props.history.location.hash)
          .replace(/\s/g, '')
          .substr(1)
          .split('#')
      : null,
    defaultFilterValues: {},
    queryParams: new URLSearchParams(window.location.search),
    isDownloading: false,
    uploadModalOpen: false,
    documentDetailModalOpen: false,
    documentDetailModalParams: {},
    documentPreviewModalOpen: false,
    documentData: {},
    fileType: '',
    is90DaysEnabled: false,
    isClickFrom90DaysButton: false,
    isDownloadClicked: false,
  };

  constructor(props) {
    super(props);
    this.tableLandingRef = React.createRef();
    if (LAUNCH_ADOBE) {
      let launch = new adobeLaunch();
      launch._load().then(() => {
        let storageService = new StorageService();
        storageService.setItem('pageName', 'documents landing');
        window.digitaldata.page.pageName = storageService.getItem('pageName');
        window.digitaldata.user.userId = storageService.getItem('userId');
      });

      fireViewStartCustomEvent({ detail: { mbox: 'target-global-mbox' } });
    }
  }
  defaultToggleValue = () => (!this.props.isApplicant && fnShowNewDashboard() ? fnGetIsAllDataFlag() : null);

  getCaseId = () => {
    let caseId = null;
    if (window.location && window.location.pathname && window.location.pathname.toLowerCase().indexOf(DOCUMENTS_CASE_COMPOSE_URL) !== -1) {
      caseId = _.last(_.split(window.location.pathname, '/'));
    }
    return caseId;
  };

  componentDidMount() {
    const __GetCaseIdOnLoad = caseId => (caseId ? { type: 'NEW_DASHBOARD_REDIRECTED', keys: [{ key: 'caseId', value: caseId }] } : null);
    let caseId = this.getCaseId();
    this.setState({
      defaultFilterValues: this.getDefaultFilterValues(caseId, this.defaultToggleValue()),
      defaultSelectedFilters: __GetCaseIdOnLoad(caseId),
    });
  }

  componentDidUpdate() {
    if (this.props.selectedMenu) {
      this.props.resetMenu(null);
      window.location.href = DOMPurify.sanitize(this.props.history.location.pathname);
    }
  }

  // this just downloads a document. should be renamed
  downloadDocument = async (id, employeeGUID) => {
    if (this.tableLandingRef && this.tableLandingRef.current) {
      await this.tableLandingRef.current.setDownloadClickedTrue();
      await this.tableLandingRef.current.showDocumentDownloadLoader();
    }

    await this.props.openDocument(id, employeeGUID);
    if (this.tableLandingRef && this.tableLandingRef.current) {
      await this.tableLandingRef.current.setDownloadClickedFalse();
      await this.tableLandingRef.current.hideDocumentDownloadLoader();
    }
  };
  previewDoc = async id => {
    if (this.tableLandingRef && this.tableLandingRef.current) {
      await this.tableLandingRef.current.setDownloadClickedTrue();
      await this.tableLandingRef.current.showDocumentDownloadLoader();
    }
    const data = await openDocumentAPI(id);
    let mimeType = 'data:' + mime.lookup(data.fileName) + ';base64,';
    this.setState({
      documentData: mimeType + data.documentData,
      documentPreviewModalOpen: true,
      fileType: data.fileName,
    });
  };

  hideConfirm = () => {
    this.setState({
      openDialog: false,
      documentIdToDelete: null,
    });
  };

  deleteDocument = documentIdToDelete => {
    this.setState({
      openDialog: true,
      documentIdToDelete,
    });
  };

  handleConfirmDelete = async () => {
    const { documentIdToDelete } = this.state;
    const { fetchData } = this.tableActions;
    //Bugfix 706206 delete document API call changed.
    await deleteDocumentWithCaseDocumentAPI(documentIdToDelete).then(res => {
      if (res && res.error) {
        throw new Error('Error deleting document.');
      }

      this.setState(
        {
          openDialog: false,
          documentIdToDelete: null,
        },
        () => {
          fetchData();
          this.props.enqueueSnackbar(intl.get('documents.notifications.successMessage'), { variant: 'success' });
        },
      );
    });
  };

  renderToolTip = (systemId, employeeNum, label1, label2) => {
    return (
      <table>
        <tbody>
          <tr>
            <td className="tipLabel">{label1}</td>
            <td className="tipLabel">{label2}</td>
          </tr>
          <tr>
            <td className="tipText">{systemId}</td>
            <td className="tipText">{employeeNum}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  getTableColumns = () => {
    const corpColumns = [
      'employee',
      'documentName',
      'documentPreview',
      'documentType',
      'documentSubType',
      'documentCountry',
      'startDate',
      'expirationDate',
      'createdOn',
    ];

    const allColumns = [
      'documentName',
      'documentPreview',
      'documentType',
      'documentSubType',
      'documentCountry',
      'startDate',
      'expirationDate',
      'createdOn',
      'dependentName',
    ];

    const columnNames = [
      'employee',
      'documentId',
      'documentName',
      'documentPreview',
      'documentType',
      'documentSubType',
      'documentCountry',
      'startDate',
      'expirationDate',
      'createdOn',
      'dependentName',
      'eyServices',
      'daysToExpiration',
      'cpsDocumentKey',
      'employeeGUID',
    ];

    const { isCorpClient } = this.props;

    /* Create columns config object used in <Table /> */
    let columns = createTableColumns('documents', {
      columns: columnNames,
      visible: isCorpClient ? corpColumns : allColumns,
      options: {
        expirationDate: {
          renderComponent: (value, options) => {
            const map = createRowMap(columns, options.row);
            let daysToExpiration = map.daysToExpiration;

            if (value && (daysToExpiration === '' || daysToExpiration === null || daysToExpiration === undefined)) {
              let expDate = toMoment(value);
              daysToExpiration = expDate.diff(toMoment(new Date()), 'days');
            }

            let daysToExpirationString =
              daysToExpiration !== 0
                ? (daysToExpiration > 90 ? '90+' : daysToExpiration) + (Math.abs(daysToExpiration) === 1 ? ' day' : ' days')
                : '';

            let id = '';
            if (daysToExpiration > 90 || !daysToExpiration) {
              id = 'green';
            } else if (daysToExpiration > 30 && daysToExpiration <= 90) {
              id = 'orange';
            } else if (daysToExpiration <= 30) {
              id = 'red';
            }

            return (
              <div className="expiration-date-cell">
                <div className="expiration-indicator-circle" id={id} />
                <div>
                  {daysToExpiration !== '' && `${daysToExpirationString} - ${extractTimeFromDate(value)}`}
                  {!daysToExpiration && value && `${extractTimeFromDate(value)}`}
                  {!daysToExpiration && !value && `No Expiration Date`}
                </div>
              </div>
            );
          },
        },
        startDate: {
          renderComponent: (value, options) => {
            return value;
          },
        },
        createdOn: {
          renderComponent: (value, options) => {
            return value;
          },
        },
        documentName: {
          renderComponent: (value, tableMeta) => {
            const handleDocumentNameClick = tableMeta => {
              let cpsDocumentKey = tableMeta.row.find(x => x.columnId === 'cpsDocumentKey');
              let employeeGUID = tableMeta.row.find(x => x.columnId === 'employeeGUID');
              if (cpsDocumentKey && employeeGUID) {
                this.downloadDocument(cpsDocumentKey.value, employeeGUID.value);
              }
            };

            return (
              <div onClick={() => handleDocumentNameClick(tableMeta)} className="document-name-link">
                {value}
              </div>
            );
          },
        },
        documentSubType: {
          renderComponent: (value, options) => {
            return value ? value : '-';
          },
        },
        documentCountry: {
          renderComponent: (value, options) => {
            return value ? value : '-';
          },
        },
        dependentName: {
          renderComponent: (value, options) => {
            return value ? value : '-';
          },
        },
        documentPreview: {
          renderComponent: (value, tableMeta) => {
            const handleDocumentClick = tableMeta => {
              let cpsDocumentKey = tableMeta.row.find(x => x.columnId === 'cpsDocumentKey');
              if (cpsDocumentKey) {
                this.previewDoc(cpsDocumentKey.value);
              }
            };
            return (
              <button className="preview-icon-button" onClick={() => handleDocumentClick(tableMeta)}>
                <img alt="info" className="ml-1" style={{ width: '75%' }} src={infoIconlabel} />
              </button>
            );
          },
        },
      },
    });

    return columns;
  };

  getFastFilters = response => {
    const { hash } = this.state;

    return [
      {
        id: 'isAll',
        label: 'All',
        value: response.allCount,
        ...(!this.state.queryParams.has('isExpiring') && { defaultSelected: hash[0] ? false : true }),
      },
      {
        id: DOCUMENTS_FAST_FILTERS.isExpiring,
        label: 'Expiring',
        value: response.expiringCount,
        selected: hash[0] === DOCUMENTS_FAST_FILTERS.isExpiring,
        ...(this.state.queryParams.has('isExpiring') && { defaultSelected: true }),
      },
      {
        id: DOCUMENTS_FAST_FILTERS.expired,
        label: 'RecentlyExpired',
        value: response.expiredCount,
        selected: hash[0] === DOCUMENTS_FAST_FILTERS.expired,
      },
      { id: 'isPostedWorker', label: 'Posted Worker', value: response.postedWorkerCount },
      { id: 'isImmigration', label: 'Immigration', value: response.immigrationCount },
      { id: 'isImmigrationBT', label: 'Immigration Assessment(BT)', value: response.immigrationBTCount },
      { id: 'isTax', label: 'Tax', value: response.taxCount },
      { id: 'isCompensation', label: 'Compensation', value: response.compensationCount },
      { id: 'isSocialSecurity', label: 'Social Security', value: response.socialSecurityCount },
    ];
  };

  toggleOptions = (filterId, response) => {
    let options = [
      { id: 'isAllData', label: intl.get('documents.filters.myData'), value: response ? response.allCount : '' },
      { id: 'allData', label: intl.get('documents.filters.allData'), value: response ? response.allCount : '' },
    ];
    if (filterId) {
      return options[filterId === 'isAllData' ? 0 : 1].label;
    }
    return options;
  };
  getToggleFilters = response => this.toggleOptions(null, response);

  getGridFilters = (isDefaultOldView, filters) => {
    const { isApplicant, isCorpClient, isTaskFlow } = this.props;
    const { documentTypes, employees, documentSubTypes, countries, caseNumber } = filters;

    /* Build Dropdown options */
    const documentTypesOpts = documentTypes ? documentTypes.map((item, index) => ({ value: item.name, label: item.name })) : [];
    const employeesOpts = employees ? employees.map((item, index) => ({ value: item.id, label: item.name })) : [];
    const documentSubTypesOpts = documentSubTypes ? documentSubTypes.map((item, index) => ({ value: item.id, label: item.name })) : [];
    const countriesOpts = countries ? countries.map((item, index) => ({ value: item.id, label: item.name })) : [];
    const caseNumberOpts = caseNumber ? caseNumber.map((item, index) => ({ value: item.id, label: item.name })) : [];

    let config = [];

    /* Create config used for <TableFilter /> */

    if (isApplicant) {
      config = [
        {
          id: 'documentType',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.documentType'),
          options: documentTypesOpts,
        },
        { id: 'uploadedDateFrom', controlType: 'Date', label: intl.get('documents.filters.labels.dateFrom') },
        { id: 'uploadedDateTo', controlType: 'Date', label: intl.get('documents.filters.labels.dateTo') },
      ];

      if (!isDefaultOldView) {
        config.push({
          id: 'caseId',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.caseNumber'),
          options: caseNumberOpts,
        });
      }
    }

    if (isCorpClient) {
      config = [
        {
          id: 'documentType',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.documentType'),
          options: documentTypesOpts,
        },
        {
          id: 'documentSubType',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.documentSubType'),
          options: documentSubTypesOpts,
          isTaskFlow,
        },
        {
          id: 'documentCountry',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.documentCountry'),
          options: countriesOpts,
        },
        !isTaskFlow && {
          id: 'employee',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.employee'),
          options: employeesOpts,
        },
        { id: 'startdateFrom', controlType: 'Date', label: intl.get('documents.filters.labels.startdateFrom') },
        { id: 'startdateTo', controlType: 'Date', label: intl.get('documents.filters.labels.startdateTo') },
        { id: 'expirationDateFrom', controlType: 'Date', label: intl.get('documents.filters.labels.expirationDateFrom') },
        { id: 'expirationDateTo', controlType: 'Date', label: intl.get('documents.filters.labels.expirationDateTo') },
        { id: 'uploadedDateFrom', controlType: 'Date', label: intl.get('documents.filters.labels.dateFrom') },
        { id: 'uploadedDateTo', controlType: 'Date', label: intl.get('documents.filters.labels.dateTo') },
      ];

      if (!isDefaultOldView) {
        config.push({
          id: 'caseId',
          controlType: 'Dropdown',
          label: intl.get('documents.filters.labels.caseNumber'),
          options: caseNumberOpts,
        });
      }
    }

    return config;
  };

  onTableChange = (actionType, data, { setTableState, fetchData }) => {
    switch (actionType) {
      case 'fastFilter':
        this.props.history.replace(window.location.pathname);
        this.setState(
          {
            defaultFilterValues: { hasCPSDocumentKey: true },
            hash: [],
          },
          () => {
            const {
              isAll,
              isExpiring,
              expired,
              recentlyExpired,
              isCompensation,
              isImmigration,
              isImmigrationBT,
              isTax,
              isPostedWorker,
              isSocialSecurity,
              isAllData,
              allData,
              ...otherFilters
            } = data;
            let newFilters = {};

            newFilters.serviceName = undefined;
            newFilters.isExpiring = undefined;
            newFilters.isExpired = undefined;
            newFilters.expirationDayFilter = undefined;
            newFilters.IsExpiringIn90Days = this.state.is90DaysEnabled;
            if (this.tableLandingRef && this.tableLandingRef.current) {
              if (this.getCaseId() === null) {
                if (!this.tableLandingRef.current.getIsCasePillFilterRemoved())
                  newFilters.caseId = this.tableLandingRef.current.getCaseId();
              } else {
                if (this.tableLandingRef.current.getIsCaseSelectedFromGrid()) newFilters.caseId = this.tableLandingRef.current.getCaseId();
                if (!this.tableLandingRef.current.getIsCasePillFilterRemoved()) newFilters.caseId = this.getCaseId();
              }
            }

            if (isAll) {
              Object.entries(otherFilters).forEach(([filter, val]) => {
                newFilters[filter] = undefined;
              });
            } else if (isExpiring) {
              newFilters.isExpiring = true;
            } else if (expired) {
              newFilters.isExpired = true;
            } else if (recentlyExpired) {
              newFilters.isExpired = true;
            } else if (isCompensation) {
              newFilters.serviceName = 'Compensation';
            } else if (isImmigration) {
              newFilters.serviceName = 'Immigration';
            } else if (isImmigrationBT) {
              newFilters.serviceName = 'Immigration Assessment(BT)';
            } else if (isTax) {
              newFilters.serviceName = 'Tax';
            } else if (isPostedWorker) {
              newFilters.serviceName = 'Posted Worker';
            } else if (isSocialSecurity) {
              newFilters.serviceName = 'Social Security';
            } else if (isAllData) {
              newFilters.isAllData = false;
            } else if (allData) {
              newFilters.isAllData = true;
            }
            setTableState({ filters: newFilters }, () => fetchData());
            if (this.tableLandingRef && this.tableLandingRef.current) this.tableLandingRef.current.resetPage();
          },
        );
        break;
      default:
        return {};
    }
  };

  handleActionMenu = (data, hideMenuFn) => {
    // overriding the default Action menu in the <Table /> because we have custom options needed for Documents action click
    // such as 'View Details', 'Delete', 'Open Document'
    const { isTaskFlow } = this.props;

    const {
      model: { columns, rows },
      rowClicked: { origRowIndex },
    } = data;

    const { documentId, cpsDocumentKey, employeeGUID } = createRowMap(columns, rows[origRowIndex]);
    //const { documentId } = createRowMap(columns, rows[origRowIndex]);
    const { history } = this.props;
    const disable = {
      pointerEvents: 'none',
      cursor: 'default',
      opacity: 0.5,
    };

    const downloadButtonLabel = intl.get('table.labels.' + (this.state.isDownloading ? 'downloadInProgress' : 'download'));

    return (
      <React.Fragment>
        {!isTaskFlow ? (
          <React.Fragment>
            <li key="view details">
              <a
                aria-label="View Details for Row"
                tabIndex={0}
                onClick={() => {
                  if (isTaskFlow) {
                    this.setState({
                      documentDetailModalOpen: true,
                      documentDetailModalParams: {
                        documentId,
                        documentKey: cpsDocumentKey,
                      },
                    });
                  } else {
                    history.push(`${DOCUMENTS_DETAIL_URL}/${documentId}/${cpsDocumentKey}`);
                  }
                  hideMenuFn();
                }}>
                <ListIcon />
                <span className="action-item-text">{intl.get('table.labels.viewDetails')}</span>
              </a>
            </li>
            <li key="download">
              <a
                aria-label="Download Document"
                style={!cpsDocumentKey || this.state.isDownloading ? disable : null}
                tabIndex={0}
                onClick={() => {
                  this.downloadDocument(cpsDocumentKey, employeeGUID);
                  hideMenuFn();
                }}>
                <DownloadIcon />
                <span className="action-item-text">{downloadButtonLabel}</span>
              </a>
            </li>
          </React.Fragment>
        ) : null}
        <li key="delete">
          <a
            aria-label="Delete Row"
            tabIndex={0}
            onClick={() => {
              this.deleteDocument(documentId);
              hideMenuFn();
            }}>
            <DeleteIcon />
            <span className="action-item-text">{intl.get('table.labels.delete')}</span>
          </a>
        </li>
      </React.Fragment>
    );
  };

  getDefaultFilterValues = (caseId, isAllData) => {
    const { hash } = this.state;
    let defaultFilterValues = { hasCPSDocumentKey: true };
    let isExpiring = this.state.queryParams.get('isExpiring') || false;
    if (hash) {
      const value = decodeURIComponent(hash[0]);
      if (value === DOCUMENTS_FAST_FILTERS.expired) {
        defaultFilterValues.isExpired = true;
        defaultFilterValues.expirationDayFilter = 0;
      } else if (value === '30days') {
        defaultFilterValues.expirationDayFilter = 1;
      } else if (value === '60days') {
        defaultFilterValues.expirationDayFilter = 2;
      } else if (value === '90days') {
        defaultFilterValues.expirationDayFilter = 3;
      } else if (value === '90+') {
        defaultFilterValues.expirationDayFilter = 4;
      } else if (value === DOCUMENTS_FAST_FILTERS.isExpiring || isExpiring) {
        defaultFilterValues.isExpiring = true;
      }
    }
    if (!(this.props.taskGroupInfo === undefined)) {
      if (this.props.isCorpClient) {
        defaultFilterValues.isApplicant = true;
      }
      defaultFilterValues.defaultEmployeeId = this.props.taskGroupInfo.employeeId;
    }
    if (caseId) {
      defaultFilterValues.caseId = caseId;
    }
    if (isAllData) {
      defaultFilterValues.isAllData = isAllData;
    }
    return defaultFilterValues;
  };

  handleDocumentViewType = async () => {
    await this.setState({ isClickFrom90DaysButton: !this.state.isClickFrom90DaysButton });
    if (this.tableLandingRef && this.tableLandingRef.current) {
      await this.tableLandingRef.current.onFilterClear();
      await this.tableLandingRef.current.resetPage();
    }
    if (this.state.isClickFrom90DaysButton) await this.setState({ is90DaysEnabled: !this.state.is90DaysEnabled });
  };

  update90DaysDocumentState = async () => {
    await this.setState({ is90DaysEnabled: false });
    if (this.tableLandingRef && this.tableLandingRef.current) await this.tableLandingRef.current.resetPage();
  };

  updateDownloadButtonState = async () => {
    await this.setState({ isDownloadClicked: false });
  };

  closeUploadModal = () => this.setState({ uploadModalOpen: false });

  closePreviewModal = async () => {
    if (this.tableLandingRef && this.tableLandingRef.current) {
      await this.tableLandingRef.current.setDownloadClickedTrue();
      await this.tableLandingRef.current.hideDocumentDownloadLoader();
    }
    this.setState({ documentPreviewModalOpen: false });
  };

  getPayloadModel = (payload, stateObj, taskGroupInfo) => {
    const { isCorpClient, isTaskFlow } = this.props;
    if (!isCorpClient || !isTaskFlow || taskGroupInfo === undefined) {
      return payload;
    }
    if (stateObj.filtersDataResponse !== null && Object.keys(stateObj.filtersDataResponse).length > 0 && stateObj.isTaskFilter) {
      if (isCorpClient) delete payload['isApplicant'];
      delete payload['defaultEmployeeId'];
    }
    if (!stateObj.isTaskFilter) {
      payload.defaultEmployeeId = taskGroupInfo.employeeId;
      if (isCorpClient) {
        payload.isApplicant = true;
      }
    }
    return payload;
  };

  handleCheckboxFilter = flag => {
    this.setState({ filterCheckBoxChecked: flag });
  };
  render() {
    let { isCase, caseId, isTaskFlow, headerDetails, isRestrictedCorpMember, taskGroupInfo } = this.props;
    const { history, hideLandingHeader, pageTitle } = this.props;
    const {
      queryParams,
      uploadModalOpen,
      documentDetailModalOpen,
      documentDetailModalParams,
      documentPreviewModalOpen,
      documentData,
      fileType,
      filterCheckBoxChecked,
    } = this.state;

    if (queryParams.has('caseId')) {
      isCase = true;
      caseId = queryParams.get('caseId');
    }
    if (this.state.isDownloading) {
      return (
        <div style={{ marginTop: '10%' }}>
          <Spinner size={70} />
        </div>
      );
    }

    const requiredDocUploadBtn = headerDetails ? !isRestrictedCorpMember : true;

    let isDefaultOldView = !fnShowNewDashboard();

    const { classes, tasks, tabIndex, docTaskId, taskId, isTaskCompleted, isTaskDocsCompleted, setCheckboxChecked } = this.props;
    const currentTaskId = !fnIsDefaultOldView() && isTaskFlow ? docTaskId : isTaskFlow ? taskId : tasks ? tasks[tabIndex].id : null;
    return (
      <Fragment>
        <div className={isDefaultOldView ? null : 'documentHeaderNew'}>
          <PageTitle title={pageTitle ? pageTitle : intl.get('documents.landing.pageTitle')} />
          {isDefaultOldView ? null : (
            <Grid container className="documentHeader justify-space-between" spacing={2} direction="row">
              <Grid item className="text-left">
                <div>
                  <div className="font-18 font-bold mb-10">{pageTitle ? pageTitle : intl.get('documents.landing.pageTitle')}</div>
                  {/* Toggle will add here */}
                  {/* <div>Toggle Will Display Here!!</div> */}
                </div>
              </Grid>
              <Grid item className="d-flex right-buttons">
                <Grid item className="add-button">
                  {
                    <Button styleType="secondary" noMaxWidth="true" onClick={() => this.handleDocumentViewType()}>
                      <VisibilityIcon />
                      <span>
                        {' '}
                        &nbsp;
                        {this.state.is90DaysEnabled
                          ? intl.get('documents.filters.viewAllDocument')
                          : intl.get('documents.filters.document90daysexpiring')}
                      </span>
                    </Button>
                  }
                </Grid>
                <Grid item>
                  {requiredDocUploadBtn && (
                    <Button
                      styleType="primary"
                      onClick={() =>
                        isTaskFlow
                          ? this.setState({ uploadModalOpen: true })
                          : history.push(
                              `${DOC_UPLOAD_NEW_URL}/${
                                this.tableLandingRef && this.tableLandingRef.current && this.tableLandingRef.current.getCaseId()
                                  ? this.tableLandingRef.current.getCaseId()
                                  : ''
                              }`,
                            )
                      }>
                      <AddIcon />
                      <span>{intl.get('documents.documentUpload.addDocumentButton')}</span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.openDialog && (
            <ConfirmDialog
              open
              title={intl.get('documents.confirmDelete.title')}
              cancelText={intl.get('documents.confirmDelete.cancel')}
              confirmText={intl.get('documents.confirmDelete.delete')}
              onCancel={this.hideConfirm}
              onConfirm={this.handleConfirmDelete}>
              <span>{intl.get('documents.confirmDelete.messageText')}</span>
            </ConfirmDialog>
          )}
          <TableLanding
            ref={this.tableLandingRef}
            isCorpClient={this.props.isCorpClient}
            isFromDocuments={isDefaultOldView ? false : true}
            defaultFilterVisibility={isDefaultOldView ? true : false}
            setCheckboxChecked={setCheckboxChecked}
            filterCheckBoxChecked={filterCheckBoxChecked}
            setCheckboxFilter={this.handleCheckboxFilter}
            history={history}
            hideLandingHeader={hideLandingHeader}
            columns={this.getTableColumns()}
            caption={intl.get('documents.tableCaption')}
            sortDirection={'desc'}
            sortColumn={'createdOn'}
            fastFilter={{
              filters: response => this.getFastFilters(response),
            }}
            toggleFilter={{
              filters: response => this.getToggleFilters(response),
            }}
            LToggle={intl.get('documents.filters.myData')}
            RToggle={intl.get('documents.filters.allData')}
            isTaskDocument={isTaskFlow}
            isTaskSubmitted={isTaskCompleted || isTaskDocsCompleted}
            switchStyles={classes}
            gridFilter={{
              filters: response => this.getGridFilters(isDefaultOldView, response),
              render: TableFilter => (
                <div className="landing-gridfilter-container">
                  {TableFilter}
                  {isDefaultOldView
                    ? requiredDocUploadBtn && (
                        <Button
                          styleType="primary"
                          disabled={isTaskCompleted || isTaskDocsCompleted || filterCheckBoxChecked}
                          onClick={() =>
                            isTaskFlow
                              ? this.setState({ uploadModalOpen: true })
                              : history.push(`${DOC_UPLOAD_NEW_URL}/${caseId ? caseId : ''}`)
                          }>
                          <span>{intl.get('documents.documentUpload.uploadButton')}</span>
                        </Button>
                      )
                    : null}
                </div>
              ),
            }}
            actionable={true}
            actionableRender={this.handleActionMenu}
            selectableRows={isTaskFlow}
            showCheckbox={isTaskFlow}
            onRequestData={isTaskFlow ? getDocumentsTasksAPI : getDocumentsAPI}
            onRequestFilters={getFiltersAPI}
            onTableChange={this.onTableChange}
            tableActions={fn => (this.tableActions = fn)}
            defaultFilterValues={{
              IsExpiringIn90Days: this.state.is90DaysEnabled,
              isApplicant: isTaskFlow ? true : this.props.isApplicant,
              caseId: isTaskFlow ? this.props.taskFlowProps.caseId : null,
              defaultEmployeeId: isTaskFlow ? this.props.caseDatacollectMenu.caseHeaderDetails.primaryEmployeeId : null,
              RequiredActionId: currentTaskId,
              ...this.state.defaultFilterValues,
            }}
            onModifyRequest={(payload, stateObj) =>
              isCase
                ? {
                    ...payload,
                    caseId: caseId,
                  }
                : this.getPayloadModel(payload, stateObj, taskGroupInfo)
            }
            doc90DaysStateHandler={async () => await this.update90DaysDocumentState()}
            is90DaysEnabled={this.state.is90DaysEnabled}
            expirationsDate={formatDate(addDays(91))}
            defaultSelectedFilters={this.state.defaultSelectedFilters}
            onLoadToggleSelectedValue={
              this.defaultToggleValue() !== null ? this.toggleOptions(fnGetIsAllDataFlag() ? 'allData' : 'isAllData') : null
            }
            isDownloadClicked={this.state.isDownloadClicked}
            updateDownloadButtonState={async () => await this.updateDownloadButtonState()}
            documentCaseId={this.getCaseId()}
            isDocument={!isTaskFlow}
          />
          <Dialog
            open={uploadModalOpen}
            onClose={this.closeUploadModal}
            aria-labelledby="dialog-title"
            fullWidth
            maxWidth="md"
            className="largemodal">
            <Fragment>
              <DialogTitle id="dialog-title">
                <IconButton aria-label="close" onClick={() => this.setState({ uploadModalOpen: false })} className="close-button">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <DocUploadContainer
                  requiredActionId={currentTaskId}
                  closeUploadModal={() => this.closeUploadModal()}
                  taskFlowProps={this.props.taskFlowProps}
                />
              </DialogContent>
            </Fragment>
          </Dialog>
          <Dialog
            open={documentDetailModalOpen}
            onClose={() => this.setState({ documentDetailModalOpen: false })}
            aria-labelledby="dialog-title"
            fullWidth
            maxWidth="md"
            className="largemodal">
            <Fragment>
              <DialogTitle id="dialog-title">
                <IconButton aria-label="close" onClick={() => this.setState({ documentDetailModalOpen: false })} className="close-button">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DocumentsDetailContainer isTaskFlow match={{ params: documentDetailModalParams }} />
            </Fragment>
          </Dialog>
          <DocumentPreviewDialog open={documentPreviewModalOpen} title={fileType} onCancel={this.closePreviewModal}>
            {fileType && <FileViewer fileType={_.last(fileType.split('.')).toLowerCase()} filePath={documentData} />}
          </DocumentPreviewDialog>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  data: state.cases.tableData,
  userInfo: getUserInfoSelector(state),
  userRoles: getUserRolesSelector(state),
  isEYPro: isEYProSelector(state),
  isApplicant: isApplicantSelector(state),
  isCorpClient: isCorpClientSelector(state),
  isCorpClientLineManager: isCorporateClientLineManagerSelector(state),
  isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
  selectedMenu: state.dashboard.selectedMenu,
  isTaskCompleted: state.caseDatacollectMenu.isTaskDocument,
});

const mapDispatchToProps = {
  openDocument: documentsActions.openDocument,
  deleteDocument: documentsActions.deleteDocument,
  addToHistory,
  storeCaseManagerId: documentsActions.storeCaseManagerId,
  resetMenu: setSelectedMenuType,
};

const dash = connect(mapStateToProps, mapDispatchToProps)(withSnackbar(DocumentsLandingContainer));
export default withStyles(useStyles)(dash);
